import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type ArtistGetProfileAboutRequest = {
  profileId: string;
};

type GetArtistProfileResponse = {
  about: string;
};

export type ArtistGetProfileAboutParams =
  RequestConfig<ArtistGetProfileAboutRequest>;

export const artistGetProfileAbout = async ({
  params,
  config
}: ArtistGetProfileAboutParams) =>
  api.get<GetArtistProfileResponse>(
    `/api/ArtistProfile/${params.profileId}/about`,
    config
  );
